<template>
  <div class="profile-details">
    <div>
      Welcome <span class="name">{{ name }}</span>
    </div>
    <div v-if="organization" class="org">{{ organization }}</div>
    <div>
      Go to your sharedo
      <a target="_blank" :href="settings.sharedoApi">home page</a> or
      <router-link to="logout">sign out</router-link>.
    </div>
  </div>
</template>
<script>
import sharedoSettings from "@/services/sharedo/sharedoSettingsService";

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    organization: {
      type: String,
      required: false,
    },
  },
  computed: {
    settings: function() {
      return sharedoSettings.get();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.profile-details {
  display: inline-block;
  flex-grow: 1;
  margin-left: 5px;
  overflow: hidden;
  height: 50px;
  font-size: 0.7rem;

  & .name,
  & a {
    color: $text-info;
  }

  & .org {
    color: $magenta;
  }
}
</style>
